<template>
    <div class="form-demo">
        <el-form label-width="80px" :model="form" size="mini">
            <el-form-item label="老密码">
                <el-input v-model="form.oldPassword" placeholder="老密码"></el-input>
            </el-form-item>
            <el-form-item label="新密码">
                <el-input v-model="form.newPassword" placeholder="新密码"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="updatePassWord">修改</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>

    //导入 HTTP请求方法
    import {
        updatePassWord
    } from '../../api/api';
    import {getmd5} from '../../global/globalMethod';

    export default{
        data(){
            return {
                form:{
                    oldPassword:'',
                    newPassword:''
                }
            }
        },
        methods:{
            updatePassWord() {
                this.form.oldPassword=getmd5(this.form.oldPassword);
                this.form.newPassword=getmd5(this.form.newPassword);
                const loading = this.$loading(this.GCONFIG.loadingParam);
                updatePassWord(this.form).then((res) => {
                    loading.close();
                    this.form.oldPassword='';
                    this.form.newPassword='';
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/sys/password.vue